export default {
	"EN":{
		"Title":"Portfolio"
	},
	"ES":{
		"Title":"Portafolio"
	}
}